import {
  Accordion,
  Card,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Badge,
} from "@mui/material";

const AccordionComponent = (props) => {
  if (props.errors === null) return null;
  else {
    const count = props.errors.length;
    return (
      <Card id="denseGroup" dense>
        {[1].map((index) => (
          <Accordion key={index}>
            <AccordionSummary>
              {props.accordionLabel}&nbsp;&nbsp;
              <Badge variant="error" sx={{ size: "0.7rem" }}>
                <Typography variant="caption">
                  {" "}
                  {count} {count > 1 ? "Errors" : "Error"}
                </Typography>
              </Badge>
            </AccordionSummary>
            <AccordionDetails>"hello world"</AccordionDetails>
          </Accordion>
        ))}
      </Card>
    );
  }
};
export default AccordionComponent;
